import { Route, Routes } from 'react-router-dom';
import './App.css';
import Appwrapper from './components/containers/Appwrapper';
import { Home, Company, Contact, Work, X404, Expertise, WorkPage, Careers, Cookies, PrivacyPolicy, Resources, Stories, Log, LogPage } from './pages';
import { Analytics } from "@vercel/analytics/react"
import { SpeedInsights } from "@vercel/speed-insights/react"


function App() {

  return (
    <Appwrapper>



      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/company" element={<Company />} />
        <Route exact path="/work" element={<Work />} />
        <Route exact path="/work/:projectId" element={<WorkPage />} />
        <Route exact path="/expertise" element={<Expertise />} />
        <Route exact path="/contact" element={<Contact />} />
        <Route exact path="/careers" element={<Careers />} />

        <Route exact path="/log" element={<Log />} />
        <Route exact path="/log/:logId" element={<LogPage />} />

        <Route exact path="/stories" element={<Stories />} />

        <Route exact path="/p/cookies" element={<Cookies />} />
        <Route exact path="/p/privacy-policy" element={<PrivacyPolicy />} />
        <Route exact path="/p/privacy" element={<PrivacyPolicy />} />
        <Route exact path="/p/resources" element={<Resources />} />
        <Route exact path="/p/ressources" element={<Resources />} />

        <Route path="/*" element={<X404 />} />
        <Route path='/404' element={<X404 />} />
      </Routes>

      {/* VERCEL */}
      <Analytics />
      <SpeedInsights />

    </Appwrapper>
  );
}

export default App;
